<style lang="scss" scoped>
.search-select {
  position: relative;
}

.search-select-input {
  appearance: none;
  text-align: left;
  cursor: pointer;
  user-select: none;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  box-shadow: none;
  border-color: #d2d6de;
  white-space: nowrap;
  display: flex;
  align-items: center;

  &:focus {
    border-color: #3c8dbc;
  }
}

.search-select-placeholder,
.search-select-text {
  flex-grow: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.search-select__arrow {
  transition: all 200ms ease-in-out;

  &::before {
    display: block;
    color: #999;
    border-style: solid;
    border-width: 5px 5px 0;
    border-color: #999 transparent transparent;
    content: '';
  }

  &__open {
    transform: rotate(180deg);
  }
}

.search-select-dropdown {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  position: absolute;
  right: 0;
  left: 0;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 50;
  border: solid 1px #d2d6de;
  display: flex;
  flex-direction: column;
}

.search-select-search {
  display: block;
  padding: 0.5rem 0.75rem;
  background-color: #ededed;
  border: 1px solid #ccc;
  margin: 0.5rem;

  // &:focus {
  //   border-color: #3c8dbc;
  // }
}

.search-select-options {
  list-style: none;
  padding: 0;
  position: relative;
  overflow-y: auto;
  max-height: 206px;
  margin: 0;
}

.search-select-option {
  padding: 4px 6px;
  cursor: pointer;
  user-select: none;
  border-bottom: solid 1px #d2d6de;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #e9e9e9;
    color: rgb(94, 94, 94);
  }

  &.is-active {
    background-color: #269add;
    color: #fff;
  }
}

.search-select-empty {
  text-align: center;
  padding: 0.5rem;
}

.father-item,
.mother-item {
  display: flex;

  img {
    width: 35px;
    height: 45px;
    object-fit: cover;
    margin-right: 0.8rem;
    align-items: center;
    border-radius: 2px;
  }

  span {
    margin-top: 14px;
  }
}

.father-item {
  margin-bottom: 4px;
}
</style>

<template>
  <on-click-outside :do="close">
    <div class="search-select" :class="{ 'is-active': isOpen }">
      <button ref="button" @click="open" type="button" class="search-select-input">
        <span v-if="option !== null" class="search-select-text"
          :title="`${option.father_name_en}, ${option.mother_name_en}`">{{ option.father_name_en }}, {{
            option.mother_name_en }}</span>
        <span v-else class="search-select-placeholder">--Select--</span>
        <span class="search-select__arrow" :class="{ 'search-select__arrow__open': isOpen }"></span>
      </button>
      <div ref="dropdown" v-show="isOpen" class="search-select-dropdown" @scroll="scrolled">
        <input class="search-select-search" v-model="search" ref="search" @keydown.esc="close" @keydown.up="highlightPrev"
          @keydown.down="highlightNext" @keydown.enter.prevent="selectHighlighted" @input="searchText" />
        <ts-loading-banner :loading="loading">
          <ul ref="options" v-show="filteredOptions.length > 0" class="search-select-options">
            <li class="search-select-option" v-for="(option, i) in filteredOptions" :key="option.parent_id"
              @click="toggleSelect(option)" :class="{ 'is-active': i === highlightedIndex }">
              <div class="father-item">
                <img v-lazy="{
                  src: option.father_photo,
                  error: require('@/assets/staff-default-man.png'),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }" />

                <span class="ts-capitalize">{{ option.father_name_en }}</span>
              </div>
              <div class="mother-item">
                <img v-lazy="{
                  src: option.mother_photo,
                  error: require('@/assets/staff-default-women.png'),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }" />
                <span class="ts-capitalize">{{ option.mother_name_en }}</span>
              </div>
            </li>
          </ul>
        </ts-loading-banner>
        <div v-show="filteredOptions.length === 0 && loading === false" class="search-select-empty">
          No parent found for
          <b>" {{ search }}"</b>
        </div>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import Popper from 'popper.js'
import { debounce, isEqual } from 'lodash'
import OnClickOutside from '@/components/OnClickOutside.vue'

export default {
  name: 'TsSelectParent',
  components: {
    OnClickOutside
  },
  props: {
    value: {
      type: Number | String
    },
    newProfile: {
      type: Number | String
    },
  },
  data() {
    return {
      options: [],
      isOpen: false,
      highlightedIndex: null,
      option: null,
      loading: false,
      perPage: 100
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  computed: {
    search: {
      get() {
        return this.$store.state.studentProfile.parent_search
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_PARENT_SEARCH', newValue)
        this.$store.commit('studentProfile/RESET_CURRENT_PAGE')
      }
    },
    filteredOptions() {
      if (this.filterFunction !== undefined) {
        return this.filterFunction(this.search, this.options)
      }

      return this.options
    },
    page() {
      return Math.ceil(this.filteredOptions.length / this.perPage + 1)
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store.dispatch('studentProfile/fetchParents').then(response => {
        this.options = response
        this.setDefaultOption()
        this.loading = false
      })
    },
    open() {
      if (!this.isOpen) {
        this.isOpen = true
        this.$nextTick(() => {
          this.setupPopper()
          this.$refs.search.focus()
          this.scrollToHighlighted()
        })
      } else {
        this.isOpen = false
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right
                data.offsets.popper.width = data.styles.width = Math.round(
                  data.offsets.reference.width
                )
                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
      this.$refs.search.focus()
    },
    toggleSelect(option) {
      if (this.option === option) {
        this.option = null
        this.$emit('input', null)
        this.$emit('change', null)
        this.highlightedIndex = null
      } else {
        this.option = option
        this.$emit('input', option.student_parent_id)
        this.$emit('change', option.student_parent_id)
        this.highlightedIndex = this.filteredOptions.indexOf(option)
      }

      // this.search = ''
      this.close()
    },
    selectHighlighted() {
      this.toggleSelect(this.filteredOptions[this.highlightedIndex])
    },
    scrollToHighlighted() {
      let index = this.highlightedIndex === null ? 0 : this.highlightedIndex

      this.$refs.options.children.length > 0 &&
        this.$refs.options.children[index].scrollIntoView({
          block: 'nearest'
        })
    },
    highlight(index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredOptions.length - 1
      }

      if (this.highlightedIndex > this.filteredOptions.length - 1) {
        this.highlightedIndex = 0
      }

      this.scrollToHighlighted()
    },
    highlightPrev() {
      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext() {
      this.highlight(this.highlightedIndex + 1)
    },
    searchText(event) {
      if (!this.isOpen) {
        this.open()

        this.$nextTick(() => {
          this.popper.scheduleUpdate()
        })
      }

      // this.loading = true

      // let debounceSearch = debounce(
      //   async function() {
      //     await this.loadData()
      //     this.loading = false
      //   }.bind(this),
      //   500
      // )
    },
    async loadData() {
      let response = await axios.get('/resource/studentdatatable', {
        params: {
          search: this.search,
          order_by: 'first_name_en',
          per_page: this.perPage,
          page: this.page
        }
      })

      response.data.forEach(el => {
        let option = this.options.find(opt => opt.student_id == el.student_id)

        if (option !== undefined) return

        this.options.push(el)
      })
    },
    async scrolled(event) {
      let scrollObject = event.target

      //visible height + pixel scrolled = total height
      if (
        scrollObject.offsetHeight + scrollObject.scrollTop >=
        scrollObject.scrollHeight
      ) {
        this.loading = true
        await this.loadData()
        this.loading = false

        event.target.scrollTo(0, scrollObject.scrollTop - 20)
      }
    },
    setDefaultImage(event) {
      event.target.src = '/img/user_default.png'
    },
    setDefaultOption() {
      let option = this.filteredOptions.find(
        opt => opt.student_parent_id === this.value
      )

      if (option === undefined) {
        this.option = null
        return
      }

      this.option = option
      this.highlightedIndex = this.filteredOptions.indexOf(option)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    isOpen(isOpen) {
      if (!isOpen) {
        // this.search = ''
      }
    },
    value: {
      handler(val) {
        if (this.option === null || this.option === undefined) return
        if (isEqual(val, this.option.student_parent_id)) return

        this.setDefaultOption()
      },
      immediate: true
    },
    newProfile: function (val) {
      this.options.push(val)
      this.setDefaultOption()
    }
  }
}
</script>
